import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import DateInput from "../../SharedComponents/DateInput";
import SelectComponent from "../../SharedComponents/SelectComponent";
import { Modal, Button } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PieCharts from "./PieCharts";
import { toastify } from "../../../helperFunctions/toastify";
import {
  getMonthFromRange,
  formatDate,
  filterTypes,
  getFilterDates,
} from "../../../helperFunctions/utils";

import {
  getComparisonOfPatientsHearAboutUs,
  getClientHearAboutUsDetail,
} from "../../../apis/dashboardReports";

import DashboardTable from "./NewDashboardTable";

const HearAboutUs = () => {
  const [hearAboutUsComparison, setHearAboutUsComparison] = useState([]);
  const [rangeMonth, setRangeMonth] = useState({
    r1: [],
    r2: [],
  });

  const [show, setShow] = useState(false);
  const [selectedDetailData, setSelectedDetailData] = useState({
    typeName: "",
    type: "",
  });
  const [detailDataResp, setDetailDataResp] = useState([]);
  const [isLoadingDataResp, setIsLoadingDataResp] = useState(false);

  const [filterType, setFilterType] = useState("last6Months");
  const [filterData, setFilterData] = useState({
    date_range: "M",
    ...getFilterDates(filterType),
    type: "R",
  });
  const [inputFilterData, setInputFilterData] = useState({
    date_range: "M",
    ...getFilterDates(filterType),
    type: "R",
  });

  const getClientHearAboutUsDetailFunc = async () => {
    setDetailDataResp([]);
    setIsLoadingDataResp(true);
    const { type, typeName, ...rest } = selectedDetailData;
    const response = await getClientHearAboutUsDetail({
      ...filterData,
      ...rest,
      type: selectedDetailData.type,
    });
    setIsLoadingDataResp(false);
    if (response.status !== "Fail") {
      setDetailDataResp(response?.data?.data);
    } else {
      toastify(response?.data?.message, "error");
    }
  };

  const getComparisonOfAge = async () => {
    const response = await getComparisonOfPatientsHearAboutUs(filterData);
    console.log("hear about us resp", response);
    if (response.status !== "Fail") {
      setHearAboutUsComparison(response?.data?.data);
    } else {
      toastify(response?.data?.message, "error");
    }
  };

  useEffect(() => {
    if (selectedDetailData.type !== "" && selectedDetailData.typeName !== "") {
      getClientHearAboutUsDetailFunc();
    }
  }, [selectedDetailData]);

  useEffect(() => {
    getComparisonOfAge();
  }, [filterData]);

  useEffect(() => {
    const firstRange = getMonthFromRange(
      filterData.r1_start_date,
      filterData.r1_end_date
    );
    const secondRange = getMonthFromRange(
      filterData.r2_start_date,
      filterData.r2_end_date
    );

    setRangeMonth({
      r1: firstRange,
      r2: secondRange,
    });
  }, [filterData]);

  const sumTotalCount = (values) => {
    let total = 0;

    rangeMonth?.r1.map((monthValue) => {
      const yearValue = values.find(
        (item) =>
          item?.year === monthValue?.year &&
          item?.month === monthValue?.month + 1
      );
      total += yearValue?.count?.length ?? 0;

      return false;
    });

    return total;
  };

  const sumTotalCount1 = (values) => {
    let total = 0;
    rangeMonth?.r2.map((monthValue) => {
      const yearValue = values.find(
        (item) =>
          item?.year === monthValue?.year &&
          item?.month === monthValue?.month + 1
      );
      total += yearValue?.count?.length ?? 0;

      return false;
    });

    return total;
  };

  const totalHearAboutUs = {
    labels: hearAboutUsComparison?.map((item) => item.period),
    yearLastCounts: hearAboutUsComparison?.map((item) =>
      sumTotalCount(item.yearLast)
    ),
    yearCurrentCounts: hearAboutUsComparison?.map((item) =>
      sumTotalCount1(item.yearCurrent)
    ),
  };

  const [options, setOptions] = useState({
    chart: {
      width: 380,
      type: "pie",
    },
    labels: [],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
    legend: {
      position: "bottom",
    },
    colors: ["#4492CDCC", "#F16F33CC", "#9B9B9BCC", "#FFB628CC"],
    dataLabels: {
      enabled: false,
    },
  });

  useEffect(() => {
    const labelOptions = hearAboutUsComparison?.map((item) => item.period);
    setOptions({
      ...options,
      labels: labelOptions,
    });
  }, [hearAboutUsComparison]);

  const { r1_start_date, r1_end_date, r2_start_date, r2_end_date } =
    inputFilterData;

  function areRangesEqualMonthCount(
    range1StartDate,
    range1EndDate,
    range2StartDate,
    range2EndDate
  ) {
    // Convert string dates to Date objects
    const r1Start = new Date(range1StartDate);
    const r1End = new Date(range1EndDate);
    const r2Start = new Date(range2StartDate);
    const r2End = new Date(range2EndDate);

    // Calculate the month count for both ranges
    const r1MonthCount =
      (r1End.getFullYear() - r1Start.getFullYear()) * 12 +
      (r1End.getMonth() - r1Start.getMonth());
    const r2MonthCount =
      (r2End.getFullYear() - r2Start.getFullYear()) * 12 +
      (r2End.getMonth() - r2Start.getMonth());

    // Check if both ranges have the same number of months
    return r1MonthCount === r2MonthCount;
  }

  const monthSame = areRangesEqualMonthCount(
    r1_start_date,
    r1_end_date,
    r2_start_date,
    r2_end_date
  );

  const handleApplyFilter = () => {
    if (!monthSame) {
      toastify("Both of range need to be match", "error");
    } else {
      setFilterData({
        ...inputFilterData,
      });
    }
  };

  useEffect(() => {
    setInputFilterData((prevFilterData) => ({
      ...prevFilterData,
      ...getFilterDates(filterType),
    }));
  }, [filterType]);

  // useEffect(() => {
  //   setFilterData((prevFilterData) => ({
  //     ...prevFilterData,
  //     ...getFilterDates(filterType),
  //   }));
  // }, []);
  const [export_PDF, setexportPDF] = useState(false);

  const handleExportPdf = () => {
    setexportPDF(true);

    setTimeout(() => {
      exportPDF();
    }, 1000);
  };
  const exportPDF = () => {
    // have a specific div with an id 'exportArea'
    // that wraps around the elements you want to export.
    const input = document.getElementById("exportArea");
    html2canvas(input, {
      scale: 2,
    }) // scale: 2 to increase the resolution of the screenshot
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.7);

        // Initialize jsPDF
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm", // Set the unit to millimeters
          format: "a4", // Set the page format to A4
        });

        // Calculate the number of pages needed for the screenshot.
        const imgWidth = 180; // A4 size page width in mm
        const pageHeight = 297; // A4 size page height in mm
        const marginTop = 10; // Top margin
        const marginBottom = 10; // Bottom margin
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight + marginTop;

        let position = marginTop;

        // Add image to the first page.
        pdf.addImage(
          imgData,
          "JPEG",
          (pdf.internal.pageSize.width - imgWidth) / 2,
          position,
          imgWidth,
          imgHeight - 10
        );
        heightLeft -= pageHeight;

        // Add new pages if the screenshot spans over multiple pages.
        while (heightLeft >= 0) {
          position = marginTop - pageHeight - marginBottom;
          pdf.addPage();
          pdf.addImage(
            imgData,
            "JPEG",
            (pdf.internal.pageSize.width - imgWidth) / 2,
            position,
            imgWidth,
            imgHeight
          );
          heightLeft -= pageHeight;
        }

        // Save the PDF
        const date = new Date();

        pdf.save(`report_${date}.pdf`);
        setexportPDF(false);
      });
  };

  return (
    <div>
      <div className="d-flex flex-wrap gap-3 w-100 px-4 py-4">
        <div className="drop-down-box col-2 me-2">
          <div className="font-400-20 mb-1">Date Presets:</div>
          <SelectComponent
            options={filterTypes}
            selectedValue={filterType}
            singleSelect
            searchEnabled
            nullDisabled
            onChange={(e) => {
              setFilterType(e.value);
              setInputFilterData({ ...inputFilterData, date_range: e.value });
            }}
          />
        </div>
        <div className="range-1">
          <div className="font-400-20 mb-2">Range 1:</div>
          <div className="date-selector-box">
            <DateInput
              value={inputFilterData.r1_start_date}
              placeholder="Start Date"
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r1_start_date: formattedDate,
                });
              }}
            />
            -
            <DateInput
              placeholder="End Date"
              value={inputFilterData.r1_end_date}
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r1_end_date: formattedDate,
                });
              }}
            />
          </div>
        </div>
        <div className="range-2">
          <div className="font-400-20 mb-2">Range 2:</div>
          <div className="date-selector-box">
            <DateInput
              value={inputFilterData.r2_start_date}
              placeholder="Start Date"
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r2_start_date: formattedDate,
                });
              }}
            />
            -
            <DateInput
              placeholder="End Date"
              value={inputFilterData.r2_end_date}
              onChange={(e) => {
                const parsedDate = new Date(e);
                const formattedDate = `${parsedDate.getFullYear()}-${(
                  parsedDate.getMonth() + 1
                )
                  .toString()
                  .padStart(2, "0")}-${parsedDate
                  .getDate()
                  .toString()
                  .padStart(2, "0")}`;
                setInputFilterData({
                  ...inputFilterData,
                  r2_end_date: formattedDate,
                });
              }}
            />
          </div>
        </div>
        <Button
          className="addItem align-self-end"
          style={{ height: "47px" }}
          onClick={() => handleApplyFilter()}
        >
          Apply
        </Button>

        <Button
          className="addItem align-self-end"
          style={{ height: "47px" }}
          onClick={() => {
            handleExportPdf();
          }}
        >
          Export
        </Button>
      </div>

      <div className="age-block" id="exportArea">
        <div className="demographic-page-block">
          {/* <h1 className="block-heading">How did you hear about us?</h1> */}
          <div className="graphs-block">
            <div className="graph-item pie-graph">
              <h2 className="year-title">
                {formatDate(filterData.r1_start_date)} -{" "}
                {formatDate(filterData.r1_end_date)}
              </h2>
              <PieCharts
                series={totalHearAboutUs.yearLastCounts}
                options={options}
              />
            </div>
            <div className="graph-item pie-graph">
              <h2 className="year-title">
                {formatDate(filterData.r2_start_date)} -{" "}
                {formatDate(filterData.r2_end_date)}
              </h2>
              <PieCharts
                series={totalHearAboutUs.yearCurrentCounts}
                options={options}
              />
            </div>
          </div>
        </div>

        <DashboardTable
          name="hearAboutUs"
          filterData={filterData}
          rangeMonth={rangeMonth}
          values={hearAboutUsComparison?.map((item) => ({
            period: item.period,
            r1year: item.yearLast,
            r2year: item.yearCurrent,
          }))}
          firstField="year"
          secondField="year"
          setShow={setShow}
          //setSelectedDetailData={setSelectedDetailData}
          setDetailDataResp={setDetailDataResp}
          export_pdf={export_PDF}
          showPercentage={true}
          showTotal={true}
        />
      </div>
      <Modal
        className=""
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Header closeButton className="pb-0" style={{ borderWidth: 0 }}>
          <div
            className="d-flex w-100 justify-content-center p-0 alert-heading"
            style={{ fontSize: "1rem" }}
          >
            {selectedDetailData.typeName.charAt(0).toUpperCase() +
              selectedDetailData.typeName.slice(1)}{" "}
            From: {filterData.r1_start_date} - {filterData.r1_end_date}
            &nbsp;&nbsp;To:&nbsp;&nbsp;
            {filterData.r2_start_date} - {filterData.r2_end_date}
          </div>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "scroll", maxHeight: 400 }}>
          <div className="mode-table-block">
            <div className="table-header">
              <div className="table-col">
                <h3 className="col-title">Date</h3>
              </div>
              <div className="table-col">
                <h3 className="col-title">Patient Name</h3>
              </div>
              <div className="table-col">
                <h3 className="col-title">Source/Recommend By</h3>
              </div>
              <div className="table-col">
                <h3 className="col-title">How Did You Hear About Us</h3>
              </div>
            </div>
            {!isLoadingDataResp ? (
              <>
                {detailDataResp?.map((item, index) => (
                  <div key={index} className="table-rows">
                    <div className="table-col">
                      <h3 className="col-title">
                        {formatDate(item.created_at)}
                      </h3>
                    </div>
                    <div className="table-col">
                      <h3 className="col-title">{item.fullName || "-"}</h3>
                    </div>
                    <div className="table-col">
                      <h3 className="col-title">{item.recommendFrom || "-"}</h3>
                    </div>
                    <div className="table-col">
                      <h3 className="col-title"> {item.hearAboutUs || "-"}</h3>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <span className="d-flex justify-content-center p-2">
                <CircularProgress />
              </span>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default HearAboutUs;
